import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

import { useDispatch } from "react-redux";

export default function DeleteAlertDialog({
  open,
  setOpen,
  setDeleteId,
  rowId,
}) {
  const agree = () => {
    setDeleteId(rowId);
  };

  const dispatch = useDispatch();

  const disagree = () => {
    dispatch({ type: "" });
    setDeleteId(-1);
    setOpen(false);
  };

  return (
    <div>
      {/* <Button variant="outlined" onClick={handleClickOpen}>
        Open alert dialog
      </Button> */}
      <Dialog
        open={open}
        onClose={() => {
          setOpen(false);
          //   dispatch({ type: "" });
        }}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">Delete</DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            Are sure you want to delete?
            {/* This will delete the row with id: {rowId} */}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button className="cancel-button" onClick={disagree}>
            Cancel
          </Button>
          <Button className="submit-button" onClick={agree} autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
